import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

/* Carte d'une sous-page sur la page d'accueil d'une entrée du menu : titre,
   une phrase, lien. Liseré gauche à la couleur du domaine (repère). */
export default function CarteLien({ titre, phrase, chemin, lisere, compteur, mention }: {
  titre: string; phrase: string; chemin: string; lisere: string;
  /** Éléments en attente (affiché s'il y en a). */
  compteur?: number | null;
  /** Mention discrète, ex. « Rangée dans Argent ». */
  mention?: string;
}) {
  return (
    <Box
      component={RouterLink}
      to={chemin}
      sx={{
        display: "flex", flexDirection: "column", gap: 0.75, textDecoration: "none", color: "var(--c-text-primary)",
        background: "var(--c-surface)", border: "1.5px solid var(--c-text-primary)", borderLeft: `6px solid ${lisere}`,
        borderRadius: "8px", p: 2, minHeight: 120,
        "&:hover, &:focus-visible": { background: "var(--c-surface-2)", outline: "none" },
        "&:hover .fleche, &:focus-visible .fleche": { transform: "translateX(3px)" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16, flex: 1 }}>{titre}</Typography>
        {compteur != null && compteur > 0 && (
          <Box component="span" sx={{ minWidth: 26, height: 22, px: 0.75, borderRadius: "6px", background: "var(--c-text-primary)", color: "#fff", fontSize: 12, fontWeight: 700, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
            {compteur}
          </Box>
        )}
      </Box>
      <Typography sx={{ fontSize: 13.5, color: "var(--c-text-secondary)", flex: 1 }}>{phrase}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 13, fontWeight: 600 }}>
        Ouvrir <ArrowForwardRoundedIcon className="fleche" sx={{ fontSize: 16, transition: "transform .15s" }} />
        {mention && <Typography component="span" sx={{ ml: "auto", fontSize: 12, color: "var(--c-text-secondary)", fontWeight: 400 }}>{mention}</Typography>}
      </Box>
    </Box>
  );
}
